<!-- 巡查记录详情 -->
<template>
  <div class="dialog-patrol">
    <div class="header">
      <div class="title">{{ '巡查记录' + ' 【' + data.qdmc + '~' + data.zdmc + '】' }}</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <div class="descriptions-item">
            <span class="key">所在河流:</span>
            <span class="value">{{ data.hl || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">所在镇街:</span>
            <span class="value">{{ data.szzjmc || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">网格员名称:</span>
            <span class="value">{{ data.zrrUserName || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">联系电话:</span>
            <span class="value">{{ data.zrrUserTel || '-' }}</span>
          </div>
          <div class="descriptions-item width100">
            <span class="key">重点监管点:</span>
            <span class="value">{{ data.prints || '-' }}</span>
          </div>
        </div>
        <div class="descriptions-group form">
          <div class="descriptions-item time">
            <n-date-picker
              v-model:value="range"
              type="daterange"
              clearable
              @change="onFilterChange"
            />
          </div>
          <div class="descriptions-item count">
            <span class="info">应巡 {{ record.yxs || '-' }} 次</span>
            <span class="info">已巡 {{ record.sxs || '-' }} 次</span>
          </div>
          <div class="descriptions-item width100">
            <n-data-table
              :columns="columns"
              :max-height="400"
              :data="tableData.data"
              :bordered="true"
              :row-props="rowProps"
            />
          </div>
          <div class="descriptions-item pagination width100">
            <span class="pagination-info">共 {{ tableData.data.length }} 项数据</span>
            <!-- <n-pagination
              :page-count="tableData.pageCount"
              :page-size="tableData.pageSize"
              :item-count="tableData.itemCount"
            >
            </n-pagination> -->
          </div>
        </div>
        <div class="descriptions-group"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted, h } from 'vue'
import { ref } from 'vue-demi'
import { Api } from '@/api/publicApi'
import Bus from '@/config/Bus'
const { proxy } = getCurrentInstance()
const props = defineProps({
  data: Object,
})
const record = ref({})
const api = new Api()
const { data } = toRefs(props)
const range = ref([new Date(new Date() - 15 * 24 * 3600 * 1000).getTime(), new Date().getTime()])
const tableData = ref({
  pageCount: ref(1),
  pageSize: ref(4),
  itemCount: ref(0),
  data: ref([]),
})
const columns = ref([
  {
    title: '序号',
    key: 'index',
    width: 70,
    align: 'center',
    render(row, index) {
      return h(
        `span`,
        {},
        {
          default: () => index + 1,
        }
      )
    },
  },
  {
    title: '开始时间',
    key: 'beginTime',
    align: 'center',
  },
  {
    title: '结束时间',
    key: 'endTime',
    align: 'center',
  },
  {
    title: '总里程（m）',
    key: 'xhlc',
    align: 'center',
    width: 115,
  },
  {
    title: '总时长',
    key: 'zsc',
    align: 'center',
  },
  {
    title: '上报问题数',
    key: 'reportProblemCount',
    align: 'center',
  },
])

const onFilterChange = (val) => {
  console.log(val)
  console.log(range)
  api.screen
    .getGridXcRecordDtoUsingPost({
      beginTime: format(val[0]),
      endTime: format(val[1]),
      userId: props.data.userId,
    })
    .then((res2) => {
      if (res2.code === 200 && res2.data) {
        record.value = res2.data
        tableData.value.data = res2.data.records
        tableData.valueitemCount = res2.data.records ? res2.data.records.legnth : 0
      } else {
      }
    })
}

function add0(m) {
  return m < 10 ? '0' + m : m
}
function format(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  const time = new Date(shijianchuo)
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  // var h = time.getHours();
  // var mm = time.getMinutes();
  // var s = time.getSeconds();
  // return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
  return y + '-' + add0(m) + '-' + add0(d)
}

function rowProps(row) {
  return {
    style: 'cursor: pointer;',
    onClick: () => {
      Bus.emit('showModal', {
        modalType: '巡查详情',
        data: row,
      })
      // alert(6)
    },
  }
}

onMounted(() => {
  onFilterChange(range.value)
})
</script>

<style lang="scss" scoped>
.dialog-patrol {
  width: 63.35rem;
  min-width: 63.35rem;
  .header {
    text-align: left;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
        }
        &.form {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .time {
            width: 40%;
          }

          :deep(.n-input--pair) {
            --n-border-hover: 1px solid#fff !important;
            --n-border-focus: 1px solid#fff !important;
          }

          ::v-deep .n-data-table-wrapper {
            border: 1px solid #fff;
          }
          ::v-deep .n-data-table .n-data-table-th,
          ::v-deep .n-data-table .n-data-table-td {
            background-color: rgb(0 136 191);
            border-color: rgb(255 255 255);
            border-bottom: 1px solid rgb(255 255 255);
          }

          .count {
            width: 50%;
            line-height: 30px;
            font-size: 12px;
            justify-content: flex-end;
            span {
              margin-right: 5px;
              &:last-of-type {
                margin-right: 0;
              }
            }
          }
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          display: flex;

          &.width100 {
            width: 100%;
          }

          &.pagination {
            display: flex;
            justify-content: space-between;
          }

          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            flex: 0 0 128px;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
